import { Injectable } from '@angular/core';

/* ref: https://ionicframework.com/docs/native/push

    import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';

    constructor(private push: Push) { }

    ...


    // to check if we have permission
    this.push.hasPermission()
      .then((res: any) => {

        if (res.isEnabled) {
          console.log('We have permission to send push notifications');
        } else {
          console.log('We do not have permission to send push notifications');
        }

      });

    // Create a channel (Android O and above). You'll need to provide the id, description and importance properties.
    this.push.createChannel({
    id: "testchannel1",
    description: "My first test channel",
    // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
    importance: 3
    }).then(() => console.log('Channel created'));

    // Delete a channel (Android O and above)
    this.push.deleteChannel('testchannel1').then(() => console.log('Channel deleted'));

    // Return a list of currently configured channels
    this.push.listChannels().then((channels) => console.log('List of channels', channels))

    // to initialize push notifications

    const options: PushOptions = {
      android: {},
      ios: {
          alert: 'true',
          badge: true,
          sound: 'false'
      },
      windows: {},
      browser: {
          pushServiceURL: 'http://push.api.phonegap.com/v1/push'
      }
    }

    const pushObject: PushObject = this.push.init(options);


    pushObject.on('notification').subscribe((notification: any) => console.log('Received a notification', notification));

    pushObject.on('registration').subscribe((registration: any) => console.log('Device registered', registration));

    pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));

*/

import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';

import { NgZone } from '@angular/core';
import { Platform, ToastController, AlertController } from '@ionic/angular';
// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service'; 
import { TranslateService } from '@ngx-translate/core';

// add my services and common stuff here
import * as Constants from 'src/app/services/constants/constants';
import { RuntimeService } from 'src/app/services/runtime/runtime.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { NotificationData } from 'src/app/services/global/structure';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';


@Injectable({
  providedIn: 'root'
})
export class PushphonegapService 
{
  private debugAlert:boolean = false;  // <<<<<<<
  private consoleLog:boolean = true;
  private token:string = "";

  constructor( private push: Push    // <<<<<<<<<<<<<<<< THIS IS WHERE THE MAGIC HAPPENS
    , private alertController: AlertController
    , public events: Events
    , public globalProvider: GlobalService
    , public notificationProvider: NotificationService
    , private commonProvider:CommonService
    , public translate: TranslateService
    , public apiProvider: ApiService 
    , public zone: NgZone 
    , public toastCtrl: ToastController
    , private runtime: RuntimeService
    , public platform: Platform
    ) 
  { 
    this.consoleLog = this.globalProvider.consoleLog_pushphonegap;
    if (this.consoleLog) console.log('PushPhonegap.ctor - LifeCycle');

    this.platform.ready().then(() => {
      this.InitializeProvider("PushPhonegap.ctor");
    });
  }

  public InitializeProvider(context:string)
  {
    this.consoleLog = this.globalProvider.consoleLog_pushphonegap;
    if (this.consoleLog) console.log('PushPhonegap.InitializeProvider - ' + context);

    try
    {
      // GO TO PANIC PAGE IF USER'S PROFILE LIMITED TO PANIC
      if (this.globalProvider.CheckAppPanicMode("PushPhonegap.InitializeProvider" + context)) 
      {
        this.PushNotSupportedPanicApp();
        return;
      }

      if (this.runtime.IsBrowser())
      {
        this.PushNotSupportedWebApp();
        return;
      }
      this.initializePushPhonegap(context);
    } 
    catch (error) 
    {
      console.error('PushPhonegap.InitializeProvider ERROR - ' + context, error);
      this.displayDebug("9: error " + context);
      //FIREBASE-YO: this.firebase.logError(error);
    }
  }

  displayDebug(message:string)
  {
    if (!this.debugAlert) { return; }
    alert("PUSH DEBUG: " + message);
  }

  PushNotSupportedPanicApp()
  {
    if (this.consoleLog) console.log('PushPhonegap.PushNotSupportedPanicApp');
    console.warn('PushPhonegap.PushNotSupportedPanicApp: panic mode does not support for push');

    let AmbitPushRegistrationStatus:string = "Panic Mode not supported";
    let AmbitPushRegistrationFlag:boolean = false;
            
    // save result in local storage as well as transient memory
    this.globalProvider.SetStorageObject_PushConfig_Registration(AmbitPushRegistrationFlag, AmbitPushRegistrationStatus);
  }

  PushNotSupportedWebApp()
  {
    if (this.consoleLog) console.log('PushPhonegap.PushNotSupportedWebApp');
    console.warn('PushPhonegap.PushNotSupportedWebApp: browser not supported for push');

    let AmbitPushRegistrationStatus:string = "Web App not supported";
    let AmbitPushRegistrationFlag:boolean = false;
            
    // save result in local storage as well as transient memory
    this.globalProvider.SetStorageObject_PushConfig_Registration(AmbitPushRegistrationFlag, AmbitPushRegistrationStatus);
  }

  initializePushPhonegap(context:string)
  {
    if (this.consoleLog) console.log('PushPhonegap.initializePushPhonegap');
    this.displayDebug("0: setting up Push " + context);

    this.setPushType();
    this.checkPermissions();
    //this.setupPushChannel();  // ignore channels...not needed for ambit
    this.setupPushListeners();
  }

  pushType:string = "";
  setPushType()
  {
    if (this.platform.is('android'))
    {
      this.pushType = Constants.PUSHTYPE_ANDROID;
    }
    else
    {
      this.pushType = Constants.PUSHTYPE_IOS;
    }
    if (this.consoleLog) console.log('PushPhonegap.setPushType: ' + this.pushType);
    //this.displayDebug("1: PushType: " + this.pushType);
  }


  checkPermissions()
  {
    if (this.consoleLog) console.log('PushPhonegap.checkPermissions');
    //this.displayDebug("10: checking permission");

    // to check if we have permission
    this.push.hasPermission()
    .then((res: any) => 
    {
      if (res.isEnabled) 
      {
        this.displayDebug("11: OK - permissions ok for push with " + this.pushType);
        console.log('We have permission to send push notifications', res);
      } 
      else 
      {
        this.displayDebug("19: ERROR - NO PERMISSIONS for push with " + this.pushType);
        console.warn('We do not have permission to send push notifications', res);
        this.DisplayMissingPermissionsWarning();
      }
    });
  }

  DisplayMissingPermissionsWarning()
  {
    let AmbitPushRegistrationStatus:string = "You must enable push in settings";
    let AmbitPushRegistrationFlag:boolean = false;
    this.globalProvider.SetStorageObject_PushConfig_Registration(AmbitPushRegistrationFlag, AmbitPushRegistrationStatus);
  
    this.commonProvider.presentToastError(AmbitPushRegistrationStatus);
  }

  // ignore channels...not needed for ambit
  setupPushChannel()
  {
    if (this.consoleLog) console.log('PushPhonegap.setupPushChannel');
    this.displayDebug("20: create channel");

    // Create a channel (Android O and above). You'll need to provide the id, description and importance properties.
    this.push.createChannel(
    {
      id: "testchannel1",
      description: "My first test channel",
      // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
      importance: 1
    })
    .then(() => 
    {
      console.log('PushPhonegap.setupPushChannel: OK Channel created');
      this.displayDebug("21: OK - channel created");
    });

    // Return a list of currently configured channels
    this.push.listChannels().then((channels) => console.log('List of channels', channels));

    // Delete a channel (Android O and above)
    //this.push.deleteChannel('testchannel1').then(() => console.log('Channel deleted'));
  }

  setupPushListeners()
  {
    if (this.consoleLog) console.log('PushPhonegap.setupPushListeners');
    this.displayDebug("30: define listeners");

    // to initialize push notifications

    /* ANDROID:  special note about icon display
        ref: https://github.com/phonegap/phonegap-plugin-push/blob/master/docs/PAYLOAD.md#images
        icon is the name of an .png image file in the Android res/drawable folder. 
        - For example: platforms/android/res/drawable/phonegap.png
        You can use a resource-file tag to copy the image to the res/drawable folder 

        You should design one with these guidelines in mind:
        - 96x96 pixels, Transparent background, White foreground
    */

    const options: PushOptions = {
      android: 
      {
        icon: 'ambitpush',
        iconColor: 'white'
      },
      ios: 
      {
          alert: 'true',
          badge: true,
          sound: 'true'
      },
      windows: {},
      browser: 
      {
          pushServiceURL: 'https://maxxess-systems.com'
      }
    }

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => 
    {
      console.log('PushPhonegap.Listener.notification: OK - Received a notification', notification); 
      this.displayDebug("31: OK - received a notification");
      this.processNotificationReceived(notification);
    });

    pushObject.on('registration').subscribe((registration: any) => 
    {
      console.log('PushPhonegap.Listener.registration: OK - Device registered with native service ' + this.pushType
                 , registration); 
      this.displayDebug("32: OK - registered with native servuce " + this.pushType);
      this.registerPushWithAmbit(registration);
    });

    pushObject.on('error').subscribe(error => 
    {
      console.log('PushPhonegap.Listener.error: Error with Push plugin', error); 
      this.displayDebug("39: ERROR - push plugin error");
    });
  }

  // ----------------------------------------------------
  // ------  HANDLE PUSH NOTIFICATION RECEIVED  ---------
  // ----------------------------------------------------
  public processNotificationReceived(notification: any)
  {
    if (this.consoleLog) console.log('PushPhonegap.handleNotificationReceived', notification);

    // ASSUMPTION:
    //  notification.message,
    //  notification.title,
    //  notification.count,
    //  notification.sound,
    //  notification.image,
    //  notification.additionalData   <<<<<<

    // any specific platform handling?
    if (this.platform.is('android')) { this.processPayloadAndroid(notification); }
    else                             { this.processPayloadIos(notification);     }

    let ForegroundStatus:string = this.GetForegroundStatus(notification);
    let notificationPayload = notification.additionalData;  // same in v5 for iOS and Android
    this.notificationProvider.HandlePushReceived(notificationPayload, ForegroundStatus);
    // NOTE: we may not want the push process to handle the badge count anymore, so 
    //       consider using the event count number instead (see HandlePushReceived above)
  }

  GetForegroundStatus(notification:any):string
  {
    if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus', notification);
    try
    {
      if ((!notification) || (!notification.additionalData))
      {
        if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus: MISSING');
        return "MISSING";
      }
      else 
      {
        // NOTE!!  These fields may no longer be supported, so just return an "PUSH" string
        // NOTE!!  These fields may no longer be supported, so just return an "PUSH" string
        // NOTE!!  These fields may no longer be supported, so just return an "PUSH" string
        // NOTE!!  These fields may no longer be supported, so just return an "PUSH" string

        // ref: https://github.com/phonegap/phonegap-plugin-push/issues/2549

        if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus: additionalData', notification.additionalData);
        if ((notification.foreground) || (notification.additionalData.foreground))
        {
          if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus: FOREGROUND');
          return "FOREGROUND";
        }
        else if ((notification.coldstart) || (notification.additionalData.coldstart))
        {
          if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus: COLDSTART');
          return "COLDSTART";
        }
        else 
        {
          if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus: NOT KNOWN');
          return "PUSH";  // do NOT use empty text as this causes an issue with inline translation
        }
        //{
        //  if (this.consoleLog) console.log('PushPhonegap.GetForegroundStatus: BACKGROUND');
        //  return "BACKGROUND";
        //}
      }
    }
    catch (error)
    {
      if (this.consoleLog) console.log('PushPhonegap.getForegroundOrBackgroundOrColdstart: ERROR', error);
      return "UNKNOWN";
    }
  }

  public processPayloadAndroid(notification: any)
  {
    if (this.consoleLog) console.log('PushPhonegap.processPayloadAndroid', notification);
    
    /* IMPORTANT QUIRKS IN ANDROID: Notification vs Data Payloads
      
      Notifications behave differently depending on the foreground/background state 
      of the receiving app and the payload you send to the app.

      Recommended format for your push payload when using this plugin 
      (while it differs from Google's docs) works 100% of the time:
      {
        "data": {
          "title": "Test Notification",
          "body": "This offer expires at 11:30 or whatever",
          "notId": 10,
          "surveyID": "ewtawgreg-gragrag-rgarhthgbad"
        }
      }

      When your app is in the foreground any on('notification') handlers you have 
      registered will be called. If your app is in the background, then the 
      notification will show up in the system tray. Clicking on the notification 
      in the system tray will start the app, and your on('notification') handler 
      will be called with the following data:

      {
        "message": "This offer expires at 11:30 or whatever",
        "title": "Test Notification",
        "additionalData": {
          "surveyID": "ewtawgreg-gragrag-rgarhthgbad"
        }
      }

    */


    /* Message Received in JavaScript

      This message is received in the push.on("notification") handler as follows. 
      Note that the properties are "normalized" across platforms, so this 
      is passed to the app on android:

      {
        "count": "5",
        "message": "The text of the alert message",
        "sound": "default",
        "title": "A short string describing the purpose of the notification",
        "additionalData": 
        {
          "custom_key1": "value1",
          "custom_key2": "value2",
          "notId": "1",
          "content_available": "0",
          "dismissed": false,
          "google.message_id": "...",
          "coldstart": false,
          "foreground": false
        }
      }
    */

   // ---------------------------------------------------------------------------

    /*  Android Message Format
        ref: https://github.com/phonegap/phonegap-plugin-push/blob/master/docs/PAYLOAD.md#android-message-format
        ref: https://developers.google.com/cloud-messaging/http-server-ref

      var content = 
      {
        priority:   'normal',   // Valid values are "normal" and "high."
        data: 
        {
          title:    'A short string describing the purpose of the notification',
          message:  'The text of the alert message',  // "body" can be used as alias, is converted to "message"
                                                      // localization of message is possible

          count:    5,                                // set the badge notification count at app icon
          sound:    'default',                        // play default sound ... or "soundname", see [Android Sound](#sound) section
          notId:    1,                                // unique ID for the message, used for grouping, see below
          'content-available': '0',                   // configure background updates, see below
          custom_key1: 'value1',
          custom_key2: 'value2'
        }
      };
    */
  }

  public processPayloadIos(notification: any)
  {
    if (this.consoleLog) console.log('PushPhonegap.processPayloadIos', notification);

    /* Message Received in JavaScript

      This message is received in the push.on("notification") handler as follows. 
      Note that the properties are "normalized" accross platforms, so this is 
      passed to the app on iOS:

      {
        "count": 5, // "badge" is converted to "count"
        "message": "The text of the alert message",
        "sound": "default",
        "title": "A short string describing the purpose of the notification",
        "additionalData": 
        {
          "category": "identifier",
          "coldstart": false,
          "foreground": false,
          "content-available": "0",
          "notId": 1,
          "custom_key1": "value1",
          "custom_key2": "value2",
          "launch-image": "The filename of an image file in the app bundle, with or without the filename extension. The image is used as the launch image when users tap the action button or move the action slider",
          "thread-id": "id"
        }
      }
    */

    // ---------------------------------------------------------------------------

    /* iOS Message Format
          ref: https://github.com/phonegap/phonegap-plugin-push/blob/master/docs/PAYLOAD.md#ios-message-format
          ref: https://developer.apple.com/library/archive/documentation/NetworkingInternet/Conceptual/RemoteNotificationsPG/PayloadKeyReference.html#//apple_ref/doc/uid/TP40008194-CH17-SW5

        The JSON message can contain the following fields, see Apple developer docs for a complete list

        {
          "aps": {
            "alert": {
              // alternatively just a string: "Your Message",
              "title": "A short string describing the purpose of the notification",
              "body": "The text of the alert message",
              // localization of message is possible
              "launch-image": "The filename of an image file in the app bundle, with or without the filename extension. The image is used as the launch image when users tap the action button or move the action slider"
            },
            "badge": 5, // Number to show at App icon
            "content-available": "0", // configure background updates, see below
            "category": "identifier", // Provide this key with a string value that represents the notification’s type
            "thread-id": "id", // Provide this key with a string value that represents the app-specific identifier for grouping notifications
            "sound": "default" // play default sound, or custom sound, see [iOS Sound](#sound-1) section
          },
          "notId": 1,
          "custom_key1": "value1",
          "custom_key2": "value2"
        }
    */

  }

  // ----------------------------------------------------
  // -------  REGISTER PUSH WITH AMBIT SERVER  ----------
  // ----------------------------------------------------
  public registerPushWithAmbit(registration: any)
  {
    if (this.consoleLog) console.log('PushPhonegap.registerPushWithAmbit');

    try
    {
      // Store on device
      let pushRegistrationId = this.getPushRegistrationId(registration);

      if (this.consoleLog) console.log('PushPhonegap.registerPushWithAmbit: store on device');
      this.globalProvider.SetStorageObject_PushConfig_Device(this.pushType, pushRegistrationId);  

      // ====================================================================================
      this.events.publish('isPushRegistrationUpdate', { PushData: pushRegistrationId });
      // ====================================================================================

      // check we are logged in
      if (!this.globalProvider.MobileUserProfile.ActiveLogin)
      {
        console.log('PushPhonegap.registerPushWithAmbit - ignoring as mobile not logged in (or data not read from storage yet)');
        return;
      }

      // store on ambit cloud server
      if (this.consoleLog) console.log('PushPhonegap.registerPushWithAmbit: store on cloud server');
      //this.displayDebug("41: about to call ambit cloud server");
      this.CallRegisterMobileForPush(this.pushType, pushRegistrationId);  
    }
    catch (error)
    {
      console.error('PushPhonegap.registerPushWithAmbit ERROR - ', error);
      this.displayDebug("49: registerPushWithAmbit error ");
    }
  }

  public getPushRegistrationId(registration:any):string
  {
    if (this.consoleLog) console.log('PushPhonegap.registerTokenWithAmbit');
    let registrationId = registration.registrationId;
    let registrationType = registration.registrationType;
    if (this.consoleLog) console.log('PushPhonegap.registerTokenWithAmbit - Type' + registrationType + ' registrationId:' + registrationId);

    return registrationId;
    /*
    registration
      registrationId: "dvY7XSCmdeI:APA91bEl2CaO5I7mhkrex1TsTWHDt1uNv1uk5KBh6CCUxKqsUR7p07w9G_NTvyiGdJh9xS7VpdxcZseTNGst5HnwbhZG9bVPb70hmKmi7yDIjrDgXQI6GxJJmSSWzB7i7kLb5KUloQzU"
      registrationType: "FCM"
    */
  }

  // ----------------------------------------------------
  // ------------        API FUNCTIONS     --------------
  // ----------------------------------------------------

  CallRegisterMobileForPush(pushType:string, pushRegistrationId:string)
  {
    if (this.consoleLog) console.log('PushPhonegap.CallRegisterMobileForPush');

    this.apiProvider.RegisterMobileForPush(pushType, pushRegistrationId)
    .then(data => { 
      this.zone.run(() => {
        this.displayDebug("51: OK - saved token on ambit cloud server");
        this.SetApiCallInfo(data);
        this.HandleApiResponse(data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        this.displayDebug("59: ERROR - unable to save token on ambit cloud server");
        this.SetApiCallInfo(errorMessage);
        this.HandleApiError(errorMessage);
        console.warn("error", errorMessage);
      });
    });
  }

  HandleApiResponse(apiResponse:any)
  {
    if (this.consoleLog) console.log('PushPhonegap.HandleApiResponse', apiResponse);

    let AmbitPushRegistrationStatus:string = "Pending response evaluation";
    let AmbitPushRegistrationFlag:boolean = false;

    if ((!apiResponse) || (!apiResponse.ApiReturn))
    {
      AmbitPushRegistrationStatus = "No API response";
      AmbitPushRegistrationFlag = false;
      this.commonProvider.presentToastError("Push Registration Error", "Unable to communicate with ambit " + apiResponse);

      let responseX:string = JSON.stringify(apiResponse);
      this.HandleApiError(responseX);
    }
    else
    {
      if (apiResponse.ApiReturn.ApiSuccessFlag)
      {
          AmbitPushRegistrationFlag = true; 
          AmbitPushRegistrationStatus = "Server Saved OK" + " (" + apiResponse.ApiReturn.ApiLogId + ")";
          //this.commonProvider.presentToast("Push Registration", "Successfully registered with ambit");
      }
      else
      {
          // this is an issue only if the user is actually logged in
          if (this.globalProvider.MobileUserProfile.ActiveLogin)
          { 
            AmbitPushRegistrationFlag = false; 
            AmbitPushRegistrationStatus = "Server Save Error" + " (" + apiResponse.ApiReturn.ApiLogId + ") ";
            this.commonProvider.presentToastError("Push Registration Error", "Unable to save push registration with ambit");
          }
          else
          {
            // v3.16
            // probably MobileDeviceGuid was not set yet, so the server cannot save this just yet
            AmbitPushRegistrationFlag = false; 
            AmbitPushRegistrationStatus = "Server Save Pending" + " (" + apiResponse.ApiReturn.ApiLogId + ") ";
          }
      }
    }
    
    // save result in local storage as well as transient memory
    this.globalProvider.SetStorageObject_PushConfig_Registration(AmbitPushRegistrationFlag, AmbitPushRegistrationStatus);
  }

  HandleApiError(errorMessage)
  {
    if (this.consoleLog) console.log('PushPhonegap.HandleApiResponse', errorMessage);

    this.commonProvider.presentToastError("Push Registration Error", "Connection Error: Unable to save push registration with ambit");

    let AmbitPushRegistrationStatus:string = "Call Error";
    let AmbitPushRegistrationFlag:boolean = false;
            
    let reasonText = this.commonProvider.GetHttpErrorReason("RegisterMobileForPush", errorMessage);
    AmbitPushRegistrationStatus = "Call Error: " + reasonText;

    //let reasonString = JSON.stringify(errorMessage);
    //if ($rootScope.pushDebug) {alert("AppController_TEMPDEBUG - reason: " + reasonString);}
    //if ($rootScope.pushDebug) {alert("AppController_TEMPDEBUG - reason: " + errorMessage.statusText + " (" + errorMessage.status + ")");}
    
    // save result in local storage as well as transient memory
    this.globalProvider.SetStorageObject_PushConfig_Registration(AmbitPushRegistrationFlag, AmbitPushRegistrationStatus);
  }


  // ----------------------------------------------------
  // --------------- COMMON SCREEN PROGRESS   -----------
  // ----------------------------------------------------

  SetApiCallInfo(apiResponse)
  {
    if (this.consoleLog) console.log('PushPhonegap.SetApiCallInfo', apiResponse);
    if ((!apiResponse) || (!apiResponse.ApiReturn)) { return; }
    //this.myapiinfoComponent.SetApiReturn(apiResponse.ApiReturn);
  }


}
